import * as React from "react";
import LandingPage from "./pages/Landing";
import { Switch, Route } from "react-router-dom";
import Final from "./pages/FinalPage/Final";
import QuestionPage from "./pages/Question";
import ResultPage from "./pages/Result/Result";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/final">
          <Final />
        </Route>
        <Route exact path="/">
          <LandingPage />
        </Route>
        <Route path="/question/:enquiryId/:tab/:id">
          <QuestionPage />
        </Route>
        <Route path="/result/:enquiryId">
          <ResultPage />
        </Route>
        <Route path="*" component={() => <h1>Page not found!</h1>} />
      </Switch>
    </div>
  );
}

export default App;
